import { AccountsForm } from './pages/accountsForm';
import { AccountsList } from './pages/accountsList';

export const AccountsRoutes = [
  {
    path: '/financeiro/contas',
    exact: true,
    component: () => <AccountsList />,
  },
  {
    path: '/financeiro/contas/novo',
    exact: true,
    component: () => <AccountsForm />,
  },
  {
    path: '/financeiro/contas/edit/:id',
    exact: true,
    component: () => <AccountsForm />,
  },
];
